import vue from "vue"
var bus=new vue()
export default  bus


// WEBPACK FOOTER //
// ./src/bus/index.js